import CS571CloudConfig from "./config.cloud";
import CS571OnPremConfig from "./config.onprem";

const CS571Configurator = CS571OnPremConfig;

export default CS571Configurator;